import classNames from "classnames";

type PinMarkerProps = {
  number: number;
  isActive: boolean;
  onClick: () => void;
  style: React.CSSProperties;
};

export const PinMarker = ({
  number,
  isActive,
  onClick,
  style,
}: PinMarkerProps) => {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={style}
      className={classNames(
        "all:unset t-absolute t-flex t-items-center t-justify-center t-w-6 t-h-6 t-rounded-full t-text-caption t-font-semibold t-text-white t-cursor-pointer t-z-10 t-transition-transform",
        {
          "t-bg-purple t-scale-125": isActive,
          "t-bg-purple-70": !isActive,
        }
      )}
    >
      {number}
    </button>
  );
};
